import axios from "axios";
import moment from "moment";
import 'moment/locale/ru';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveComponent, setLogs } from "../../Reducer/RevenueModuleSlice";
import { roleId } from "../Constants/app";
moment.locale('ru');

export default function EnteringDataRM() {
    const SelectedCity = useSelector(state => state.RevenueModuleSlice.selectedCity);
    const SelectedMonth = useSelector(state => state.RevenueModuleSlice.selectedMonth);
    const fio = useSelector(state => state.UserSlice.User.user.FIO);
    const User = useSelector(state => state.UserSlice.User);
    const Server = useSelector(state => state.UserSlice.Server);

    const [prev, setPrev] = useState(null);
    const [daysData, setDaysData] = useState({});
    const [ loading, setLoading ] = useState(false);

    const dispatch = useDispatch();
    
    const getData = async () => {
        setLoading(true);

        const date = moment(`${SelectedMonth.YearValue}-${SelectedMonth.MonthValue}`);
        const daysInMonth = date.daysInMonth();

        const data = {
            month: SelectedMonth.MonthValue,
            year: SelectedMonth.YearValue,
            idCity: SelectedCity.id,
        };
        
        const newDaysObject = {};
        for (let day = 1; day <= daysInMonth; day++) {
            const currentDate = moment(`${SelectedMonth.YearValue}-${SelectedMonth.MonthValue}-${day}`);
            const dateKey = currentDate.format('DD.MM.YYYY');
            
            newDaysObject[dateKey] = {
                date: dateKey,
                dayOfWeek: currentDate.format('dddd'),
                plannedRevenue: null,
                revenueTotal: null,
                revenueYE: null,
                revenueKuper: null,
                revenueOnline: null,
                revenueCash: null,
                revenueNoncash: null,
                cashierFIO: null,
                logs: [],
            };
        }

        const response = await axios.post(Server + 'revenuereports/getOne', data, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        });

        if (response && response.data) {
            setPrev(response.data);
            const responseDaysData = response.data.daysData;
            if (responseDaysData) {
                Object.entries(responseDaysData[0] || []).forEach(([date, data]) => {
                    newDaysObject[date] = data;
                })
            }
            
        }
        setDaysData(newDaysObject);
        setLoading(false);
    } 

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SelectedMonth]);

    const calculateTotal = (data) => {
        let result = null;
        if (data.revenueYE) result += parseFloat(data.revenueYE);
        if (data.revenueKuper) result += parseFloat(data.revenueKuper);
        if (data.revenueOnline) result += parseFloat(data.revenueOnline);
        if (data.revenueCash) result += parseFloat(data.revenueCash);
        if (data.revenueNoncash) result += parseFloat(data.revenueNoncash);
        return result;
    }

    const onChangeInput = (date, field, value) => {
        setDaysData(prev => {
            const updatedData = {...prev};
            updatedData[date] = {
                ...updatedData[date],
                [field]: value,
            };

            if (field !== 'cashierFIO' && field !== 'plannedRevenue') updatedData[date].revenueTotal = calculateTotal(updatedData[date]);
            return updatedData;
        });
    };

    const onBlurInput = (date, field, value) => {
        const prevValue = (prev && prev.daysData[0] && prev.daysData[0][date] && prev.daysData[0][date][field]) ? prev.daysData[0][date][field] : null;
        if (!value && !prevValue) return null;
        setDaysData(prev => {
            const updatedData = {...prev};
            updatedData[date] = {
                ...updatedData[date],
                logs: [                    
                    {
                        prevValue,
                        field,
                        value,
                        fio,
                        datetime: moment().format('DD.MM.YYYY HH:mm:ss'),
                    },
                    ...updatedData[date].logs,
                ]
            };
            return updatedData;
        });
    }
    
    const handleClickSaveButton = async () => {
        setLoading(true);
        const filteredDaysData = Object.fromEntries(
            Object.entries(daysData).filter(([key, value]) => value.logs && value.logs.length > 0)
        );

        const data = {
            id: prev.id,
            updated_at: prev.updated_at,
            month: SelectedMonth.MonthValue,
            year: SelectedMonth.YearValue,
            idCity: SelectedCity.id,
            daysData: [filteredDaysData],
        };

        const response = await axios.post(Server + 'revenuereports/setData', data, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        });
        if (response && response.data) {
            setPrev(response.data);
            const newDaysObject = daysData;
            const responseDaysData = response.data.daysData;
            if (responseDaysData) {
                Object.entries(responseDaysData[0]).forEach(([date, data]) => {
                    newDaysObject[date] = data;
                })
                setDaysData(newDaysObject);
            }
        }
        setLoading(false);
    }

    const handleClickLogs = (logs) => {
        dispatch(setLogs(logs));
    }

    const handleClickBack = () => {
        dispatch(setActiveComponent('enteringDataMenu'))
    };

    const handleClickMainMenu = () => {
        dispatch(setActiveComponent(null));
    }

    const calculatePlanExecution = (planned, actual) => {
        if (!planned || !actual) return '';
        const plannedNum = parseFloat(planned);
        const actualNum = parseFloat(actual);
        if (plannedNum === 0) return '0%';
        return `${((actualNum / plannedNum) * 100).toFixed(2)}%`;
    };

    if (loading) return(
        <div className="ModalGlobalDiv" >
            <div className="BigSpin" />
        </div>
    )

    return (
        <div className="GlobalDivRevenueCity" style={{ width: 'auto' }}>
            <div className="DivFlex Gap">
                <div className="revenueTitle" style={{ minWidth: '300px' }}>{SelectedCity.City} {SelectedCity.Adress} {SelectedMonth.Name}</div>
                <button className="ExitButton" style={{ width: 'auto', padding: '0px 10px '}} onClick={handleClickBack} >
                    Назад
                </button>
                {User.user.role.id !== roleId.cashier && <button className="ExitButton" style={{ width: 'auto', padding: '0px 10px '}} onClick={handleClickMainMenu} >
                    Главное меню
                </button>}
            </div>
            <div style={{ height: '10px' }}></div>
            
            <div className="table-container">
                <table>
                    <thead>
                        <tr className="sticky-header">
                            <th className="revenueTitle">Дата</th>
                            <th className="revenueTitle">День недели</th>
                            <th className="revenueTitle">Плановая выручка</th>
                            <th className="revenueTitle">Выполнение плана (%)</th>
                            <th className="revenueTitle">Выручка фактическая общая (руб)</th>
                            <th className="revenueTitle">Выручка ЯЕ/ДК (руб)</th>
                            <th className="revenueTitle">Выручка Купер (руб)</th>
                            <th className="revenueTitle">Выручка ЮКасса (руб)</th>
                            <th className="revenueTitle">Наличные в кассе (руб)</th>
                            <th className="revenueTitle">Безналичные (руб)</th>
                            <th className="revenueTitle">Кассир (ФИО)</th>
                            <th className="" style={{ backgroundColor: 'white'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(daysData).map(([date, item]) => (
                            <tr key={date}>
                                <td className="revenueCell">{date}</td>
                                <td className="revenueCell">{item.dayOfWeek}</td>
                                <td className="revenueCell input-cell">
                                    <input 
                                        type="number"
                                        value={item.plannedRevenue || ''}
                                        onChange={(e) => onChangeInput(date, 'plannedRevenue', e.target.value)}
                                        onBlur={(e) => onBlurInput(date, 'plannedRevenue', e.target.value)}
                                        className="table-input"
                                    />
                                </td>
                                <td className="revenueCell">
                                    {calculatePlanExecution(item.plannedRevenue, item.revenueTotal)}
                                </td>
                                <td className="revenueCell input-cell">
                                    {item.revenueTotal}
                                </td>
                                <td className="revenueCell input-cell">
                                    <input 
                                        type="number"
                                        value={item.revenueYE || ''}
                                        onChange={(e) => onChangeInput(date, 'revenueYE', e.target.value)}
                                        onBlur={(e) => onBlurInput(date, 'revenueYE', e.target.value)}
                                        className="table-input"
                                    />
                                </td>
                                <td className="revenueCell input-cell">
                                    <input 
                                        type="number"
                                        value={item.revenueKuper || ''}
                                        onChange={(e) => onChangeInput(date, 'revenueKuper', e.target.value)}
                                        onBlur={(e) => onBlurInput(date, 'revenueKuper', e.target.value)}
                                        className="table-input"
                                    />
                                </td>
                                <td className="revenueCell input-cell">
                                    <input 
                                        type="number"
                                        value={item.revenueOnline || ''}
                                        onChange={(e) => onChangeInput(date, 'revenueOnline', e.target.value)}
                                        onBlur={(e) => onBlurInput(date, 'revenueOnline', e.target.value)}
                                        className="table-input"
                                    />
                                </td>
                                <td className="revenueCell input-cell">
                                    <input 
                                        type="number"
                                        value={item.revenueCash || ''}
                                        onChange={(e) => onChangeInput(date, 'revenueCash', e.target.value)}
                                        onBlur={(e) => onBlurInput(date, 'revenueCash', e.target.value)}
                                        className="table-input"
                                    />
                                </td>
                                <td className="revenueCell input-cell">
                                    <input 
                                        type="number"
                                        value={item.revenueNoncash || ''}
                                        onChange={(e) => onChangeInput(date, 'revenueNoncash', e.target.value)}
                                        onBlur={(e) => onBlurInput(date, 'revenueNoncash', e.target.value)}
                                        className="table-input"
                                    />
                                </td>
                                <td className="revenueCell input-cell">
                                    <input 
                                        value={item.cashierFIO || ''}
                                        onChange={(e) => onChangeInput(date, 'cashierFIO', e.target.value)}
                                        onBlur={(e) => onBlurInput(date, 'cashierFIO', e.target.value)}
                                        className="table-input"
                                    />
                                </td>
                                {item.logs && item.logs.length > 0 && <td style={{ padding: '10px'}}>
                                    <button onClick={() => handleClickLogs(item.logs)} className="FilterButtonAR" style={{ width: 'auto', padding: '5px' }}> log </button>
                                </td>}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button className="SaveButton" onClick={handleClickSaveButton} >
                Сохранить
            </button>
        </div>
    );
}